<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-cancellation"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill-rule="evenodd"
    >
      <path
        d="M12,22 C9.35499706,22 6.86166472,20.9741591 4.97499881,19.1099932 C4.95999882,19.0999932 4.94333216,19.0866598 4.9266655,19.0691598 C4.9166655,19.0583265 4.9041655,19.0433265 4.89249884,19.0274932 C3.02749959,17.1408273 2,14.6466616 2,12 C2,6.48583154 6.48583154,2 12,2 C14.6449949,2 17.1391606,3.02583292 19.0249932,4.88999884 C19.0391599,4.89999884 19.0541598,4.9116655 19.0691598,4.9266655 C19.0816598,4.93833216 19.0949932,4.95499882 19.1074932,4.97249881 C20.9733257,6.85916472 22,9.35333039 22,12 C22,17.5141605 17.5141605,22 12,22 Z M6.27499829,18.60916 C7.86833099,19.9924928 9.88833018,20.7499925 11.999996,20.7499925 C16.8249941,20.7499925 20.7499925,16.8249941 20.7499925,11.999996 C20.7499925,9.88833018 19.9924928,7.86833099 18.60916,6.27499829 L6.27499829,18.60916 Z M11.999996,3.2499995 C7.17499793,3.2499995 3.2499995,7.17499793 3.2499995,11.999996 C3.2499995,14.1116618 4.00833253,16.131661 5.39083198,17.7249937 L17.7249937,5.39083198 C16.131661,4.00833253 14.1116618,3.2499995 11.999996,3.2499995 Z"
      />
    </g>
  </svg>
</template>
